export const HOTEL_HOLD_TS_PREFIX = 'hotel_hold_ts_';
export const HOTEL_SESSION_EXPIRES_AT_PREFIX = 'hotel_session_expires_at_';
